import { render, staticRenderFns } from "./ReportActionsComponent.vue?vue&type=template&id=0bd1662c&scoped=true&"
import script from "./ReportActionsComponent.vue?vue&type=script&lang=js&"
export * from "./ReportActionsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportActionsComponent.vue?vue&type=style&index=0&id=0bd1662c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd1662c",
  null
  
)

export default component.exports